import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL, PHONE, PHONE_TEL } from "@/lib/site-data";

const NAV = [
  { id: "services", label: "Services" },
  { id: "realisations", label: "Réalisations" },
  { id: "pourquoi", label: "Pourquoi nous" },
  { id: "avis", label: "Avis" },
  { id: "zones", label: "Zones" },
  { id: "contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled ? "bg-black/85 backdrop-blur-md border-b border-bgtp-line" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-8 py-3">
        <a href="#top" onClick={(e) => { e.preventDefault(); go("top"); }} data-testid="header-logo-link" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="BGTP" className="h-12 w-12 object-cover rounded-sm border border-bgtp-line" />
          <div className="leading-none">
            <div className="font-heading text-2xl tracking-wider"><span className="silver-text">BG</span><span className="text-bgtp-orange">TP</span></div>
            <div className="text-[10px] text-bgtp-steel tracking-[0.25em] uppercase">Terrassement · Rénovation</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="text-sm uppercase tracking-[0.18em] text-white/80 hover:text-bgtp-orange transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="header-call-btn"
            href={`tel:${PHONE_TEL}`}
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 border border-bgtp-orange text-bgtp-orange hover:bg-bgtp-orange hover:text-black font-heading tracking-wider uppercase text-sm transition-colors"
          >
            <Phone className="w-4 h-4" /> {PHONE}
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 border border-bgtp-line text-white"
            aria-label="Menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black/95 border-t border-bgtp-line">
          <div className="px-5 py-4 flex flex-col gap-2">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => go(n.id)}
                className="text-left py-3 border-b border-bgtp-line uppercase tracking-[0.2em] text-sm text-white/90"
              >
                {n.label}
              </button>
            ))}
            <a
              data-testid="mobile-call-btn"
              href={`tel:${PHONE_TEL}`}
              className="mt-3 inline-flex items-center justify-center gap-2 py-3 bg-bgtp-orange text-white font-heading tracking-wider uppercase"
            >
              <Phone className="w-4 h-4" /> Appeler maintenant
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
